import { app } from '@store/modules/app';
import { flattenQueryParam } from '@utils/request';
import { FundriseRouteConfig } from 'vue-router';
import { getVanityUrlMetadata } from '@api/vanity';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const modularLandingPageRoutes: FundriseRouteConfig[] = [
	{
		path: `/campaigns/:campaignName`,
		name: 'campaign-partner-custom',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		props: true,
		component: () =>
			import(
				/* webpackChunkName: "modular-campaign-landing-page" */ '@views/marketing-site/modular-landing-page.vue'
			)
	},
	{
		path: '/starter-portfolio',
		name: 'starter-landing-page',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		props: {
			campaignName: 'starter-portfolio'
		},
		component: () =>
			import(/* webpackChunkName: "starter-landing-page" */ '@views/marketing-site/modular-landing-page.vue')
	},
	{
		path: `/acq-plus/start`,
		name: 'campaign-default',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		props: {
			campaignName: 'acq-plus-start',
			isAcqPlusStart: true
		},
		component: () =>
			import(
				/* webpackChunkName: "modular-acqplus-start-landing-page" */ '@views/marketing-site/modular-landing-page.vue'
			)
	},
	{
		path: `/affiliates/no-fees`,
		name: 'campaign-nofees',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		props: {
			campaignName: 'affiliates-no-fees',
			isAffiliateNoFees: true
		},
		component: () =>
			import(
				/* webpackChunkName: "modular-affiliates-no-fees-landing-page" */ '@views/marketing-site/modular-landing-page.vue'
			)
	},
	{
		path: `/referral-program/welcome`,
		name: 'referral-program-welcome-redirect',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: async (to, from, next) => {
			const inviteKey = flattenQueryParam(to.query.referralKey);

			if (inviteKey) {
				next({
					name: 'referral-welcome',
					query: {
						inviteKey
					}
				});
			} else {
				next({ name: 'home' });
				app.ADD_TOAST({
					type: 'error',
					message: 'The invite is not valid'
				});
			}
		}
	},
	{
		path: `/invitation-program/welcome`,
		name: 'referral-welcome',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		props: {
			campaignName: 'invitation-program-welcome',
			isInvitationProgram: true
		},
		component: () =>
			import(
				/* webpackChunkName: "modular-invitation-program-landing" */ '@views/marketing-site/modular-landing-page.vue'
			)
	},
	{
		path: `/partner`,
		name: 'campaign-partner-default',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		props: {
			campaignName: 'partner'
		},
		component: () =>
			import(/* webpackChunkName: "campaign-partner-default" */ '@views/marketing-site/campaign/partner.vue')
	},
	{
		path: `/partner-promo`,
		name: 'campaign-partner-promo',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		props: {
			campaignName: 'partner-promo'
		},
		component: () =>
			import(/* webpackChunkName: "campaign-partner-promo" */ '@views/marketing-site/campaign/partner.vue')
	},
	{
		path: `/advanced-investing`,
		name: 'high-end-offerings',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () =>
			import(/* webpackChunkName: "premium-landing-page" */ '@views/marketing-site/premium-landing-page.vue')
	},
	{
		path: `/partner/:vanityUrlSlug`,
		alias: [`/campaign/:vanityUrlSlug`],
		name: 'vanity-url-default',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: async (to, from, next) => {
			try {
				const vanityUrlMetadata = await getVanityUrlMetadata(to.params.vanityUrlSlug);
				next(vanityUrlMetadata.redirectUrl);
			} catch (error) {
				next({ name: '404' });
			}
		}
	}
];

export default modularLandingPageRoutes;
